<template>
    <el-dialog
        title="选择发票"
        :visible.sync="invoiceDialogVisible"
        width="800px" class="invoiceTitleDialogBox">
        <div class="invoiceTitleDialog">
            <el-tabs v-model="activeName" @tab-click="searchInvoiceInfo">
                <el-tab-pane label="电子发票" name="DZFP"></el-tab-pane>
                <el-tab-pane label="纸质发票" name="ZZFP"></el-tab-pane>
            </el-tabs>
            <div class="electronicInvoice" v-if="activeName === 'DZFP'">
                <h3>请选择发票</h3>
                <div class="invoiceList">
                    <div class="invoiceItem" v-for="(item,index) in electronicInvoiceList" :key="index">
                        <el-checkbox v-model="item.checked" class="invoiceCheckBox"
                                     @change="invoiceCheckChange(item)"></el-checkbox>
                        <div>
                            <div class="type">
                                {{item.invoiceType=='SPECIAL'?'专用发票':'普通发票'}} ({{item.billType=='ENTERPRISE'?'企业':'个人'}})
                            </div>
                            <div class="name">{{item.title}}</div>
                            <div class="num" v-if="item.code">{{item.code}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="electronicInvoice" v-if="activeName === 'ZZFP'">
                <h3>请选择发票</h3>
                <div class="invoiceList">
                    <div class="invoiceItem" v-for="(item,index) in electronicInvoiceList" :key="index">
                        <el-checkbox v-model="item.checked" class="invoiceCheckBox"
                                     @change="invoiceCheckChange(item)"></el-checkbox>
                        <div>
                            <div class="type">
                                {{item.invoiceType=='SPECIAL'?'专用发票':'普通发票'}}
                            </div>
                            <div class="name">{{item.title}}</div>
                            <div class="num" v-if="item.code">{{item.code}}</div>
                        </div>
                    </div>
                </div>
                <h3>请选择收票地址</h3>
                <div class="addressList">
                    <div :class="item.checked?'active addressItem':'addressItem'" v-for="(item,index) in invoiceAddressList" :key="index">
                        <el-checkbox class="checkBox" v-model="item.checked" @change="invoiceAddressChecked(item)"></el-checkbox>
                        <div class="name">{{item.receiverName}} <el-button v-if="item.checked" type="text" icon="el-icon-edit" style="padding: 0;position: relative;z-index: 9;" @click="toEditAddress(item)"></el-button></div>
                        <div class="tel">{{item.mobile}}</div>
                        <div class="address">{{ item.province }}{{ item.city }}{{ item.district }}{{ item.areaInfo }}</div>
                        <img v-if="item.checked" src="@/assets/addressBorder.png" class="addressBorder">
                    </div>
                </div>
            </div>
            <div class="buttonGroup">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="selectInvoice">选择</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import { findBuyerPrintOrderDetail,getAddressList,invoiceTitleList,savePrintReceipt } from '../../../utils/interface';
    export default {
        name: "cancelOrder",
        data(){
            return{
                // 申请开票
                invoiceDialogVisible:false,
                activeName:"DZFP",
                invoiceType:"NORMAL",
                invoiceUuid:"",
                payeeUuid:"",
                electronicInvoiceList:[],
                invoiceAddressList:[],
                invoiceForm:{},
                invoiceInfo:"",
                dialogVisibleDialog: false,
                printOrderUuid: "",
                orderBaseUuid: "",
            }
        },
        methods: {
            init(printOrderUuid,orderBaseUuid){
                this.orderBaseUuid = orderBaseUuid;
                this.printOrderUuid = printOrderUuid;
                findBuyerPrintOrderDetail({uuid:this.printOrderUuid}).then((res)=>{
                    if(res){
                        if(res.receipt!=null) {
                            // 发票类型
                            this.activeName = res.receipt.invoiceType;
                            if(this.activeName==="DZFP"){
                                this.invoiceType = "NORMAL";
                            }else if(this.activeName==="ZZFP"){
                                this.invoiceType = "";
                            }
                            // 查询开票地址
                            this.invoiceUuid = res.receipt.invoiceUuid;
                            // 查询接收发票地址
                            this.payeeUuid = res.receipt.payeeUuid;
                        }
                        // 查询发票地址，如果保存过发票地址则回显
                        this.getInvoiceList();
                        // 查询接收地址，如果存在地址则回显
                        this.getAddressList();
                    }
                });
                this.invoiceDialogVisible = true;
            },
            searchInvoiceInfo(){
                if(this.activeName==="DZFP"){
                    this.invoiceType = "NORMAL";
                }else if(this.activeName==="ZZFP"){
                    this.invoiceType = "";
                }
                this.electronicInvoiceList = [];
                this.getInvoiceList();
            },
            // 选择电子发票复选框
            invoiceCheckChange(val) {
                this.electronicInvoiceList.map(item => {
                    if (val.uuid !== item.uuid) {
                        item.checked = false
                    } else {
                        item.checked = val.checked
                    }
                })
            },
            invoiceAddressChecked(val) {
                this.invoiceAddressList.map(item => {
                    if (item.uuid === val.uuid) {
                        item.checked = val.checked
                    } else {
                        item.checked = false
                    }
                })
            },
            getInvoiceList(){
                let params = {
                    invoiceType:this.invoiceType
                };
                invoiceTitleList(params).then((res)=>{
                    if(res&&res.length>0){
                        res.map(item=>{
                            if(this.invoiceUuid!='') {
                                if (item.uuid == this.invoiceUuid) {
                                    item.checked = true;
                                } else {
                                    item.checked = false;
                                }
                            }else{
                                if (item.isDefault) {
                                    item.checked = true;
                                } else {
                                    item.checked = false;
                                }
                            }
                        });
                    }
                    this.electronicInvoiceList = res;
                });
            },
            getAddressList(){
                getAddressList().then((res)=>{
                    res.data.map(items => {
                        if(this.payeeUuid!=''){
                            if(items.uuid == this.payeeUuid){
                                items.checked = true;
                            }else {
                                items.checked = false;
                            }
                        }else{
                            if(items.defaultVal==1){
                                items.checked = true;
                            }else {
                                items.checked = false;
                            }
                        }
                    });
                    this.invoiceAddressList = res.data;
                });
            },
            selectInvoice() {
                if (this.activeName === 'DZFP') {
                    let electronicInvoiceSelected = this.electronicInvoiceList.filter(item => {
                        return item.checked === true
                    });
                    if (electronicInvoiceSelected.length <= 0) {
                        this.$message.warning('请选择发票!')
                    } else {
                        // 电子发票
                        // 查询企业还是个人
                        this.invoiceForm.printOrderUuid = this.printOrderUuid;
                        this.invoiceForm.invoiceType = this.activeName;
                        this.invoiceForm.invoiceUuid = electronicInvoiceSelected[0].uuid;
                    }
                } else {
                    let paperInvoiceSelected = this.electronicInvoiceList.filter(item => {
                        return item.checked === true
                    });
                    let addressSelected = this.invoiceAddressList.filter(item => {
                        return item.checked === true
                    });
                    if (paperInvoiceSelected.length <= 0) {
                        this.$message.warning('请选择发票!')
                    } else if (addressSelected.length <= 0) {
                        this.$message.warning('请选择收票地址!')
                    } else {
                        this.invoiceForm.printOrderUuid = this.printOrderUuid;
                        this.invoiceForm.invoiceType = this.activeName;
                        this.invoiceForm.invoiceUuid = paperInvoiceSelected[0].uuid;
                        this.invoiceForm.payeeUuid = addressSelected[0].uuid;
                    }
                }
                savePrintReceipt(this.invoiceForm).then((res)=>{
                    if(res.success){
                        this.$message.success('申请成功!');
                        this.invoiceDialogVisible = false;
                        this.$emit('invoiceAddressSuccess')
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
.addressDialog{
    /deep/.el-dialog__header{
        border-bottom: 1px solid #ddd;
    }
    /deep/.el-dialog__body{
        padding: 0;
    }
    .submitButtonGroup{
        text-align: right;
        margin-bottom: 0;
        border-top: 1px solid #ddd;
        padding: 10px 30px;
    }
}
.addressList{
    padding: 24px 30px 20px;
    display: flex;
    flex-wrap: wrap;
    .addressItem{
        padding: 14px 22px;
        margin-bottom: 24px;
        margin-right: 30px;
        position: relative;
        width: 270px;
        border-radius: 8px;
        border: 2px dashed #E3E3E3;
        font-size: 14px;
        .addressBorder{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        &.active{
            border: 2px dashed #fff;
        }
        &:nth-of-type(4n){
            margin-right: 0;
        }
        .checkBox{
            position: absolute;
            right: 22px;
            top: 14px;
        }
        .name{
            color: #000;
        }
        .tel{
            color: rgba(51, 51, 51, 0.85);
            padding: 6px 0;
        }
        .address{
            color: rgba(51, 51, 51, 0.85);
            line-height: 22px;
        }
    }
    .addItem{
        text-align: center;
        cursor: pointer;
        color: #666;
        &:hover{
            border: 2px dashed #1890FF;
        }
        .icon{
            font-size: 30px;
        }
        .addName{
            font-size: 14px;
            padding-top: 5px;
        }
    }
}
.electronicInvoice {
    h3 {
        padding-bottom: 15px;
        color: #000;
        font-size: 15px;
    }

    .invoiceList {
        .invoiceItem {
            border: 1px solid #ddd;
            padding: 10px 50px 10px 15px;
            border-radius: 10px;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            position: relative;

            .invoiceCheckBox {
                padding-right: 15px;
            }

            .type {
                font-size: 12px;
                color: #666;
                padding-bottom: 5px;
            }

            .name {
                font-size: 15px;
                color: #000;
                padding-bottom: 5px;
            }

            .num {
                font-size: 12px;
                color: #333;
            }

            .edit {
                position: absolute;
                right: 15px;
                top: 50%;
                margin-top: -10px;
                padding: 0;
            }
        }
    }

    .emailList {
        padding: 0 15px 15px;

        /deep/ .el-radio {
            margin-bottom: 15px;
            display: block;
            margin-right: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/invoiceAddress.vue